<script setup lang="ts">
import { onBeforeUnmount } from 'vue';
import { useTracking } from '@/composables/useTracking';
const { logout } = useTracking();

import { useUserStore } from './store/modules/user';
import PagePerformanceMonitor from './components/PagePerformanceMonitor.vue';

// 初始化用户状态
const userStore = useUserStore();
userStore.restoreUserState();

// 退出登录时，清除埋点用户ID
onBeforeUnmount(() => {
  logout();
});
</script>

<template>
  <router-view />
  <!-- 页面性能监控组件 -->
  <PagePerformanceMonitor 
    :enable-api-monitoring="true"
    :enable-web-vitals="true"
    :enable-api-tracking="true"
    container-type="H5"
  />
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
